import { FunctionComponent, useEffect, useState } from "react";
import { makeStyles } from "tss-react/mui";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import SettingsIcon from "@mui/icons-material/Settings";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import {DRAWER_WIDTH, DRAWER_WIDTH_CLOSED} from "@/Components/Sidebar/Constants";
import ExitToAppOutlinedIcon from "@mui/icons-material/ExitToAppOutlined";
import {useHistory, useLocation} from "react-router-dom";
import Logo from "@/Style/crentweb-logo.png";
import {CLOSE_SIDEBAR, OPEN_SIDEBAR} from "@/Redux/App/AppConstants";
import {Drawer, FormControlLabel, ListItemButton, Theme,} from "@mui/material";
import {useAppDispatch, useAppSelector} from "@/Redux/Redux";
import _ from "lodash";
import {AUTH_LOGOUT_SAGA} from "@/Redux/Auth/AuthConstants";
import GroupIcon from "@mui/icons-material/Group";
import FindInPageIcon from "@mui/icons-material/FindInPage";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import {RequestPage} from "@mui/icons-material";
import PaymentIcon from "@mui/icons-material/Payment";
import {CHANGE_STATION_START} from "@/Redux/Disposition/Constants";
import {useSelector} from "react-redux";
import {selectViewerEnabledStations, ViewerState,} from "@/Redux/Auth/AuthReducer";
import MuiSelect from "@mui/material/Select";
import LocalGroceryStoreIcon from "@mui/icons-material/LocalGroceryStore";
import Icon from "@mdi/react";
import {mdiCalendarQuestionOutline, mdiSteering, mdiTransfer} from "@mdi/js";
import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";
import {useTranslation} from "@/Utils/CustomHooks/useTranslation";


interface SidebarProps {
}

const useStyles = makeStyles()((theme: Theme) => ({
    drawerOpen: {
        width: DRAWER_WIDTH,
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: 0,
        }),
    },

    drawerClose: {
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: 0,
        }),
        overflowX: "hidden",
        width: DRAWER_WIDTH_CLOSED,
    },

    toolbar: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        //...theme.mixins.toolbar,
    },
    customerLogo: {
        marginLeft: "auto",
        marginRight: "auto",
    },
    listItem: {
        color: "#fff",
    },
    listItemIcon: {
        color: "#fff !important",
    },
    fixedBottom: {
        right: 0,
        left: 0,
        bottom: 0,
        zIndex: 1030,
    },
    crwLogo: {
        padding: ".5rem 1.25rem",
        textAlign: "center",
    },
    version: {
        width: "100%",
        marginBottom: 10,
        textAlign: "center",
        fontSize: '12px'
    },
    nested: {
        paddingLeft: theme.spacing(4),
    },
    active: {
        backgroundColor: "#e42022!important",
        borderColor: "#e42022!important",
        fontWeight: 600,
    },
    select: {
        paddingTop: 0,
        paddingBottom: 0,
        color: "white",
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "white !important",
        },
        "& .MuiNativeSelect-icon": {
            color: "white",
        },
    },
}));

const Sidebar: FunctionComponent<SidebarProps> = (): JSX.Element => {
    const {classes, cx} = useStyles();
    const dispatch = useAppDispatch();
    const app = useAppSelector((state) => state.app);
    const [mandant, setMandant] = useState(app.mandant?.data);
    const [mandantLogo, setMandantLogo] = useState(app.mandant?.data?.logo);
    const [configurationOpen, setConfigurationOpen] = useState(false);
    const [dispositionOpen, setDispositionOpen] = useState(false);
    const history = useHistory();

    const toggleDrawer = () => {
        if (app.sidebarIsOpen) {
            dispatch({type: CLOSE_SIDEBAR});
        } else {
            dispatch({type: OPEN_SIDEBAR});
        }
    };



    useEffect(() => {
        setMandantLogo('#');
        setMandant(app.mandant?.data);
        setTimeout(setMandantLogo, 200, app.mandant?.data?.logo.replace('force_reload=false', 'force_reload=true&timestamp=' + new Date().getUTCMilliseconds()));
    }, [app]);

    const location = useLocation();
    const {t} = useTranslation();

    function handleLogout() {
        dispatch({type: AUTH_LOGOUT_SAGA});
    }

    const isActive = (pathname: string, exact: boolean = false) => {
        if (exact) {
            return location.pathname === pathname;
        }
        return _.includes(location.pathname, pathname);
        //return pathname === location.pathname;
    };
    const appDispatch = useAppDispatch();
    const {selectedStation} = useAppSelector((state) => state.disposition);
    const enabledStations = useSelector((state) =>
        selectViewerEnabledStations(state as ViewerState)
    );
    const renderSelect = () => {
        return (
            <MuiSelect
                className={classes.select}
                variant={"outlined"}
                size={"small"}
                //style={{height: 'calc(1.5em + .5rem)'}}
                style={{
                    color: "white",
                    borderColor: "white !important",
                }}
                native
                value={selectedStation || ""}
                onChange={(e) => {
                    appDispatch({
                        type: CHANGE_STATION_START,
                        payload: e.target.value,
                    });
                }}
            >
                {enabledStations
                    .filter(
                        (station: any) => station.isChangeableInDispo == "J"
                    )
                    .map((station: { stationId: string; name: string }) => (
                        <option
                            key={station.stationId}
                            value={station.stationId}
                        >
                            {station.stationId} - {station.name}
                        </option>
                    ))}
            </MuiSelect>
        );
    };

    return (
        <Drawer
            transitionDuration={0}
            id="sidebar"
            variant="permanent"
            className={cx({
                [classes.drawerOpen]: app.sidebarIsOpen,
                [classes.drawerClose]: !app.sidebarIsOpen,
            })}
            classes={{
                paper: cx({
                    [classes.drawerOpen]: app.sidebarIsOpen,
                    [classes.drawerClose]: !app.sidebarIsOpen,
                }),
            }}
        >
            <div className={classes.toolbar}>
                <IconButton
                    className={classes.listItemIcon}
                    onClick={toggleDrawer}
                >
                    {!app.sidebarIsOpen ? (
                        <ArrowForwardIcon/>
                    ) : (
                        <ArrowBackIcon/>
                    )}
                </IconButton>
            </div>
            <div className={classes.customerLogo}>
                {app.initialized && app.sidebarIsOpen && (
                    <img
                        className="mand-menu-collapsed"
                        src={mandantLogo}
                        alt="Mandant Logo"
                        style={{width: "100%"}}
                    />
                )}
            </div>
            <FormControlLabel
                style={{
                    fontSize: ".875rem !important",
                    color: "white",
                }}
                control={renderSelect()}
                label={t("disposition.controls.rentalAtStation")}
                labelPlacement={"top"}
            />
            <Divider/>
            <List>
                <ListItemButton
                    className={cx(
                        classes.listItem,
                        isActive("/manager/disposition", true)
                            ? classes.active
                            : ""
                    )}
                    onClick={() => {
                        history.push("/manager/disposition");
                    }}
                    dense
                >
                    <ListItemIcon className={classes.listItemIcon}>
                        <EventNoteOutlinedIcon/>
                    </ListItemIcon>
                    <ListItemText primary={t("sidebar.disposition")}/>
                </ListItemButton>
                <ListItemButton
                    className={cx(classes.listItem, isActive('/manager/log') ? classes.active : '')}
                    dense
                    onClick={() => {
                        history.push("/manager/log");
                    }}
                >
                    <ListItemIcon className={classes.listItemIcon}>
                        <Icon path={mdiTransfer} size={1}/>
                    </ListItemIcon>
                    <ListItemText primary={t('sidebar.log')}/>
                </ListItemButton>
                <ListItemButton
                    className={cx(
                        classes.listItem,
                        isActive(
                            "/manager/disposition/reservations",
                            true
                        )
                            ? classes.active
                            : ""
                    )}
                    dense
                    onClick={() => {
                        history.push(
                            "/manager/disposition/reservations"
                        );
                    }}
                >
                    <ListItemIcon className={classes.listItemIcon}>
                        <Icon path={mdiCalendarQuestionOutline} size={1}/>
                    </ListItemIcon>
                    <ListItemText
                        primary={t("sidebar.reservationlog")}
                    />
                </ListItemButton>
                <ListItemButton
                    dense
                    key={"customers"}
                    className={cx(
                        classes.listItem,
                        isActive("/manager/customers", true) ||
                        isActive("/manager/customer/")
                            ? classes.active
                            : ""
                    )}
                    onClick={() => {
                        history.push("/manager/customers");
                    }}
                >
                    <ListItemIcon className={classes.listItemIcon}>
                        <GroupIcon/>
                    </ListItemIcon>
                    <ListItemText primary={t("sidebar.customers")}/>
                </ListItemButton>
                <ListItemButton
                    dense
                    className={cx(
                        classes.listItem,
                        isActive("/manager/suppliers", true) ||
                        isActive("/manager/supplier/")
                            ? classes.active
                            : ""
                    )}
                    onClick={() => {
                        history.push("/manager/suppliers");
                    }}
                >
                    <ListItemIcon className={classes.listItemIcon}>
                        <LocalGroceryStoreIcon/>
                    </ListItemIcon>
                    <ListItemText primary={t("sidebar.suppliers")}/>
                </ListItemButton>
                <ListItemButton
                    dense
                    className={cx(
                        classes.listItem,
                        isActive("/manager/transfer-drivers", true) ||
                        isActive("/manager/transfer-driver/")
                            ? classes.active
                            : ""
                    )}
                    onClick={() => {
                        history.push("/manager/transfer-drivers");
                    }}
                >
                    <ListItemIcon className={classes.listItemIcon}>
                        <Icon path={mdiSteering} size={1}/>
                    </ListItemIcon>
                    <ListItemText primary={t("sidebar.transfer-drivers")}/>
                </ListItemButton>
                <ListItemButton
                    dense
                    key={"bookings"}
                    className={cx(
                        classes.listItem,
                        isActive("/manager/bookings", true) ||
                        isActive("/manager/contract/") ||
                        isActive("/manager/reservation/") ||
                        isActive("/manager/transfer/") ||
                        isActive("/manager/transfer-reservation/")
                            ? classes.active
                            : ""
                    )}
                    onClick={() => {
                        history.push("/manager/bookings", {from: "sidebar"});
                    }}
                >
                    <ListItemIcon className={classes.listItemIcon}>
                        <FindInPageIcon/>
                    </ListItemIcon>
                    <ListItemText primary={t("sidebar.bookings")}/>
                </ListItemButton>
                <ListItemButton
                    className={cx(
                        classes.listItem,
                        isActive("/manager/invoices", true) ||
                        isActive("/manager/invoice/")
                            ? classes.active
                            : ""
                    )}
                    dense
                    onClick={() => {
                        history.push("/manager/invoices");
                    }}
                >
                    <ListItemIcon className={classes.listItemIcon}>
                        <RequestPage/>
                    </ListItemIcon>
                    <ListItemText primary={t("sidebar.invoice-search")}/>
                </ListItemButton>
                <ListItemButton
                    dense
                    key={"vehicles"}
                    className={cx(
                        classes.listItem,
                        isActive("/manager/vehicles", true) ||
                        isActive("/manager/vehicle/")
                            ? classes.active
                            : ""
                    )}
                    onClick={() => {
                        history.push("/manager/vehicles");
                    }}
                >
                    <ListItemIcon className={classes.listItemIcon}>
                        <DirectionsCarIcon/>
                    </ListItemIcon>
                    <ListItemText primary={t("sidebar.vehiclesearch")}/>
                </ListItemButton>
                <ListItemButton
                    dense
                    key={"accountingBook"}
                    className={cx(
                        classes.listItem,
                        isActive("/manager/accounting-book")
                            ? classes.active
                            : ""
                    )}
                    onClick={() => {
                        history.push("/manager/accounting-book");
                    }}
                >
                    <ListItemIcon className={classes.listItemIcon}>
                        <PaymentIcon/>
                    </ListItemIcon>
                    <ListItemText primary={t("sidebar.accountingBook")}/>
                </ListItemButton>
                {/*<ListItemButton
                          dense
                          key={"offers"}
                          className={cx(classes.listItem, isActive('/offers') ? classes.active : '')}
                          onClick={() => {
                            history.push("/manager/offers");
                            }}>
                    <ListItemIcon className={classes.listItemIcon}><LocalOfferIcon/></ListItemIcon>
                    <ListItemText primary={t('sidebar.Offer')}/>
                </ListItemButton>*/}
                {<ListItemButton
                    dense
                    key={"queries"}
                    className={cx(
                        classes.listItem,
                        isActive("/manager/queries") ? classes.active : ""
                    )}
                    onClick={() => {
                        history.push("/manager/queries");
                    }}
                >
                    <ListItemIcon className={classes.listItemIcon}>
                        <QuestionMarkIcon/>
                    </ListItemIcon>
                    <ListItemText primary={t("sidebar.queries")}/>
                </ListItemButton>}
            </List>

            <Divider/>
            <div
                className={classes.fixedBottom}
                style={{
                    position: configurationOpen ? "sticky" : "absolute",
                    top: configurationOpen ? "100%" : "auto",
                }}
            >
                <List>
                    <ListItemButton
                        dense
                        key={"configuration"}
                        className={cx(
                            classes.listItem,
                            isActive("/configuration") ? classes.active : ""
                        )}
                        onClick={() => {
                            history.push("/manager/configuration/dashboard");
                        }}
                    >
                        <ListItemIcon className={classes.listItemIcon}>
                            <SettingsIcon/>
                        </ListItemIcon>
                        <ListItemText primary={t("sidebar.configure")}/>
                    </ListItemButton>
                    <ListItemButton
                        dense
                        key={"logout"}
                        className={classes.listItem}
                        onClick={handleLogout}
                    >
                        <ListItemIcon className={classes.listItemIcon}>
                            <ExitToAppOutlinedIcon/>
                        </ListItemIcon>
                        <ListItemText primary={t("sidebar.logout")}/>
                    </ListItemButton>
                </List>
                <div className={classes.crwLogo}>
                    {app.sidebarIsOpen && (
                        <img
                            className="mand-menu-collapsed"
                            src={Logo}
                            alt="CRW Logo"
                            style={{width: "100%"}}
                        />
                    )}
                </div>
                <div className={classes.version}>
                    <p style={{margin: 0}}>
                        {t("sidebar.version")} {!app.sidebarIsOpen && <br/>}{" "}
                        {import.meta.env.VITE_VERSION}
                    </p>
                </div>
            </div>
        </Drawer>
    );
};

export default Sidebar;
